import { isEmpty } from 'lodash';

import { FrozenFieldsAfterPrefill } from 'api/api';

import { BillingFSMPayload, RecipientFSMPayload } from '../state-machines/shared-types';
import { isDeliveryAddressEmpty } from './prepare-address';

export const getModalTitle = (
  machineContext: RecipientFSMPayload['context'] | BillingFSMPayload['context'],
  frozenFields?: FrozenFieldsAfterPrefill['fields']
) => {
  if (machineContext.externalAddressBookProvider) {
    if (isEmpty(machineContext.currentAddress)) {
      return 'widget.delivery_address.ADD_DIFFERENT_ADDRESS';
    } else if (machineContext.currentAddress?.is_dirty) {
      return 'widget.delivery_address.CONFIRM_ADDRESS';
    } else {
      return 'widget.delivery_address.EDIT_MODAL.TITLE';
    }
  } else {
    if (isDeliveryAddressEmpty(machineContext.currentAddress || {}, frozenFields)) {
      return 'widget.delivery_address.ADD_DIFFERENT_ADDRESS';
    } else {
      return 'widget.delivery_address.EDIT_MODAL.TITLE';
    }
  }
};
